<template lang="pug">
	section#blockTitulo
		h1 {{ content.titulo }}
		h2(v-if="content.subtitulo") {{ content.subtitulo }}
		.content(v-html="content.text", v-if="content.text")
</template>

<script>
export default {
	name: "component-block-titulo",
	props: {
		content: {
			type: Object,
			required: true
		}
	},
}
</script>

<style lang="stylus" scoped src="./BlockTitulo.styl"></style>
